import React from 'react';
import { Modal } from '@beef/ui-kit';
import { DevicePreview } from "../DevicePreview";
import { FlocktoryAnalytics } from "./components";
export var DeviceModal = function DeviceModal(_ref) {
  var _data$id;
  var isOpen = _ref.isOpen,
    isLoading = _ref.isLoading,
    type = _ref.type,
    purchaseData = _ref.purchaseData,
    data = _ref.data,
    onClose = _ref.onClose,
    onChangeType = _ref.onChangeType,
    onChangeColor = _ref.onChangeColor,
    subscribeData = _ref.subscribeData,
    isFavoriteSelected = _ref.isFavoriteSelected,
    setFavorite = _ref.setFavorite,
    size = _ref.size;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DevicePreview, {
    data: data,
    isFavoriteSelected: isFavoriteSelected,
    isLoading: isLoading,
    onChangeColor: onChangeColor,
    onChangeType: onChangeType,
    purchaseData: purchaseData,
    setFavorite: setFavorite,
    size: size,
    subscribeData: subscribeData,
    type: type
  }), !!(data !== null && data !== void 0 && data.isFlocktory) && /*#__PURE__*/React.createElement(FlocktoryAnalytics, {
    brand: data.brand,
    categoryId: data.categoryId,
    id: data.flocktoryId || ((_data$id = data.id) === null || _data$id === void 0 ? void 0 : _data$id.toString()),
    isOutOfStock: data.isOutOfStock
  }));
};